import Vue from "vue";
import Router from "vue-router";
import routes from "./router/routes";
import { isMobile } from "@/util/helpers.js";
import { gtmTrack, gtmUntrack } from "@/util/gtm";

Vue.use(Router);

const router = new Router({
	scrollBehavior(to, from, savedPosition) {
		const SCROLL_DURATION_IN_MS = 250;
		// We don't want to do a scroll top if we're in the bld section

		//covid-scroll
		if (to.name == "home" && to.hash == "#prebuild-section") {
			return $("html,body")
				.stop()
				.animate(
					{
						scrollTop: 690
					},
					SCROLL_DURATION_IN_MS
				);
		}

		if (to.hash && !to.path.toLowerCase().includes("bld")) {
			const HEADER_HEIGHT = 100;
			return $("html,body")
				.stop()
				.animate(
					{
						scrollTop: $(to.hash).offset().top - HEADER_HEIGHT
					},
					SCROLL_DURATION_IN_MS
				);
		} else {
			return $("html,body")
				.stop()
				.animate(
					{
						scrollTop: 0
					},
					SCROLL_DURATION_IN_MS
				);
		}
	},
	mode: "history",
	routes
});

router.beforeEach((to, from, next) => {
	if (to.meta.disallowInPosMode && window.CONFIG.POS_MODE) {
		next({ name: "home" });
	}

	// Track into GTM the visited prebuilds
	gtmTrack.prebuildVisitedByRoute(to);

	// From will be empty if accessing the site from an external link.
	if (!from.name) {
		if (isMobile() && to.name == "step4") {
			const newTo = _.cloneDeep(to);
			newTo.name = "step4-mobile";
			next(newTo);
		} else if (!isMobile() && to.name == "step4-mobile") {
			const newTo = _.cloneDeep(to);
			newTo.name = "step4";
			next(newTo);
		}
	}

	const bodyEl = document.querySelector("body");

	bodyEl.classList.forEach(classNanme => {
		if (classNanme.includes("zd-widget-move-")) {
			bodyEl.classList.remove(classNanme);
		}
	});

	// Apply classes to move zendesk widget depending on the route
	if (["step1", "step3", "step5"].includes(to.name)) {
		bodyEl.classList.add(`zd-widget-move-${to.name}`);
	}

	$(".modal").modal("hide");
	EventBus.$emit("route-changed", to, from);

	// Redirect to home if a section needs auth and the user is not logged in
	const userIsLoggedIn = Cookies.get("cookies_id");
	if (to.matched.some(record => record.meta.requiresAuth) && !userIsLoggedIn) {
		// We should redirect to a login form
		next({
			path: "/",
			query: {
				redirect: to.fullPath,
				login: true
			}
		});
	} else {
		const shouldNotBeLogged = to.matched.some(
			record => record.meta.shouldNotBeLogged
		);
		// we redirect the user to home if he tries to enter in a route that should not be logged in to see
		if (shouldNotBeLogged && userIsLoggedIn) {
			return next({
				name: "home"
			});
		}
		next();
	}

	bodyEl.classList.remove("bg-black");

	if (from.hash.includes("draft")) {
		const draftId = from.hash.split("=").pop();
		const userSession = window.CONFIG.SESSION;
		axios
			.put(`/users/0/letsbld-drafts/${draftId}?session=${userSession}`)
			.then(() => {})
			.catch(error => {});
	}
});

router.afterEach((to, from) => {
	let checkoutFlowState = undefined;
	const prebuildCheckoutFlow = ["accessories", "cart"];
	let fromGroup = from.meta.group;
	let fromPrebuildRoute = (from.path || "").split("/").pop();

	const toGroup = to.meta.group;
	const toPrebuildRoute = (to.path || "").split("/").pop();

	const lastVisitedPrebuild = sessionStorage.getItem(
		"last-prebuild-in-checkout-flow"
	);
	if (lastVisitedPrebuild) {
		const { group, path } = JSON.parse(lastVisitedPrebuild);
		fromGroup = group;
		fromPrebuildRoute = path
			.substring(1)
			.split("/")
			.pop();
		sessionStorage.removeItem("last-prebuild-in-checkout-flow");
	}

	if (prebuildCheckoutFlow.includes(fromPrebuildRoute)) {
		const isSameGroup = toGroup == fromGroup;
		const toIsInCheckout = prebuildCheckoutFlow.includes(toPrebuildRoute);
		if (!toIsInCheckout || !isSameGroup) {
			checkoutFlowState = false;
		}
	}

	if (checkoutFlowState === false) {
		gtmTrack.userCheckoutCanceled();
	} else {
		gtmUntrack.userCheckout();
	}
});

export default router;
